export default require("./node_modules/react-image-crop/dist/ReactCrop.min.js");